import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const ViewPreferencesContext = createContext();
const STORAGE_KEY = "ezfunc-display-view";

function readView() {
    try {
        const saved = localStorage.getItem(STORAGE_KEY) ?? localStorage.getItem("ezfunc-pool-density");
        return saved === "compact" ? "compact" : "standard";
    } catch (error) {
        console.warn("Display preference could not be read:", error);
        return "standard";
    }
}

export function ViewPreferencesProvider({ children }) {
    const [view, setView] = useState(readView);
    useEffect(() => {
        try { localStorage.setItem(STORAGE_KEY, view); }
        catch (error) { console.warn("Display preference could not be saved:", error); }
    }, [view]);
    const changeView = useCallback(value => {
        if (value !== "standard" && value !== "compact") throw new Error(`Unsupported display view: ${value}`);
        setView(value);
    }, []);
    const value = useMemo(() => ({ view, setView: changeView }), [view, changeView]);
    return <ViewPreferencesContext.Provider value={value}>{children}</ViewPreferencesContext.Provider>;
}

export function useViewPreferences() {
    const context = useContext(ViewPreferencesContext);
    if (!context) throw new Error("useViewPreferences must be used within a ViewPreferencesProvider");
    return context;
}
